module.exports = __webpack_public_path__ + "contacts-cbf4f629/Background_01_4x3_a-75efada4079d687e1af86f6274a07848.svg";